<template>
  <span role="checkbox" tabindex="0" :aria-checked="getChecked" 
      :title="label"
      :aria-label="label"
      :class="getChecked ? getOnColor : getOffColor"
      @click="getChecked = !getChecked"
      class="relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:shadow-outline">
    <span aria-hidden="true" 
      :class="getChecked ? 'translate-x-5' : 'translate-x-0'"
      class="translate-x-0 relative inline-block h-5 w-5 rounded-full bg-white shadow transform transition ease-in-out duration-200">
      <span 
          :class="getChecked ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200'"
          class="absolute inset-0 h-full w-full flex items-center justify-center transition-opacity">
      </span>
      <span 
          :class="getChecked ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100'"
          class="absolute inset-0 h-full w-full flex items-center justify-center transition-opacity">
      </span>
    </span>
  </span>

</template>

<script>
export default {
    emits: [
        'changed'
    ],
    props: {
        checked : {
            type: Boolean,
            required: true,
            default: false
        },
        label : {
          type: [String, Boolean],
          required: true
        },
        onColor: {
          type: String,
          default: 'blue',
          required: false,
        },
        offColor: {
          type: String,
          default: 'gray',
          required: false,
        }
    },
    computed: {
        getChecked: {
            get() {
                return this.checked;
            },
            set(value) {
                this.$emit('changed', value);
            }
        },
        getOnColor() {
            switch(this.onColor) {
                case 'dark-gray' :
                    return 'bg-bhav-cool-gray-600'
                case 'gray' :
                    return 'bg-bhav-cool-gray-100'
                case 'green' :
                    return 'bg-bhav-green-600'
                case 'blue' :
                default :
                    return 'bg-bhav-blue-500'
            }
        },
        getOffColor() {
            switch(this.offColor) {
                case 'gray' :
                    return 'bg-bhav-cool-gray-100'
                case 'green' :
                    return 'bg-bhav-green-600'
                case 'blue' :
                default :
                    return 'bg-bhav-blue-500'
            }
        },
    }
}
</script>